






import { Component, Vue } from "vue-property-decorator";
@Component
export default class About extends Vue {
  mounted() {
    console.log("about mounted");
  }
}
